import { IconNewTab, IconNight, IconSettings, IconSun } from "@flixbus/honeycomb-icons-react";
import { HeaderSubNavigation, NavItem } from "@flixbus/honeycomb-react";
import * as React from "react";
import { FormattedMessage } from "react-intl";
import { Feature, hasUserPermission, logout } from "../../../auth";
import { commonPathnames, getUserPreferredLanguage, setUserPreferredLanguage, internalLocales } from "../../../helper";
import LanguageSwitcher from "../../languageSwitcher/LanguageSwitcher";
import formatMessage from "../../translationProvider/helpers/formatMessage/formatMessage";
import * as css from "../Navigation.scss";

const getWidgetNavigation = (isDarkTheme: boolean, toggleTheme: () => void, isMobile: boolean = false) => {
  const selected = getUserPreferredLanguage();
  const locale = internalLocales.find((lang) => lang.locale === selected);

  return (
    <HeaderSubNavigation id="user-sub-menu">
      {hasUserPermission(Feature.USER_HAS_MUS_ACCESS) ? (
        <NavItem key="PersonalSettings" href={commonPathnames.mus} InlineIcon={IconSettings} extraClasses={css.icon}>
          <FormattedMessage id="navigation.personalSettings" />
        </NavItem>
      ) : (
        <></>
      )}
      <NavItem
        key="toggleTheme"
        onClick={toggleTheme}
        Elem="button"
        InlineIcon={isDarkTheme ? IconNight : IconSun}
        extraClasses={css.icon}
      >
        <FormattedMessage id="navigation.toggleTheme" />
      </NavItem>
      {locale ? (
        <NavItem key="switchLanguage" Elem="div">
          <LanguageSwitcher
            currentLanguage={locale}
            languages={[
              {
                region: formatMessage("navigation.switchLanguage"),
                locales: internalLocales,
              },
            ]}
            onLanguageSelected={setUserPreferredLanguage}
          />
        </NavItem>
      ) : (
        <></>
      )}
      <NavItem
        key="MobilityPartnerPortal"
        href={commonPathnames.mpp}
        Elem="a"
        InlineIcon={IconNewTab}
        target="_blank"
        extraClasses={css.icon}
      >
        <FormattedMessage id="navigation.MobilityPartnerPortal" />
      </NavItem>
      <NavItem key="logout" onClick={logout} Elem="button" extraClasses={isMobile ? undefined : css.logout}>
        <FormattedMessage id="navigation.logout" />
      </NavItem>
    </HeaderSubNavigation>
  );
};

export default getWidgetNavigation;
